import React from 'react';
import {Box, Tr, Td} from '@chakra-ui/react';

const TableRow = ({children}) => {
  return (
      <Tr>
        <Td colSpan={2}>
          <Box pl={4}>
            {children}
          </Box>
        </Td>
      </Tr>
  );
}

export default TableRow;